const namespaceClass = '[Clever]';

export const CLEVER_GET_STUDENTS = `${namespaceClass} CLEVER GET STUDENTS`;
export const CLEVER_REQUEST_FAILED = `${namespaceClass} CLEVER REQUEST FAILED`;
export const CLEVER_SELECT_STUDENT = `${namespaceClass} CLEVER SELECT STUDENT`;
export const CLEVER_GET_STUDENTS_IN_PROGRESS = `${namespaceClass} CLEVER GET STUDENTS IN PROGRESS`;
